import { useQuery } from '@tanstack/react-query';

import { TEN_MINUTES_IN_MS, THIRTY_MINUTES_IN_MS } from '@/legacy/constants';
import { AVAILABLE_DELEGATIONS } from '@/legacy/constants/queryKeys';

import { fetchAvailableDelegations } from '../service/availableDelegations';
import { mapAvailableDelegations } from '../mappers/availableDelegations';

/**
 * Which delegations the user may take into `company`, and whether picking one is mandatory.
 *
 * Unlike `useDelegationOptions` (`/forms/delegations`, a plain option list for filters), this is
 * a login endpoint: it answers "what would this user's scope be in that company", which is why
 * it carries `mandatory`. Kept as a module-level `select` so the mapped result — including the
 * `renderLabel` elements — stays referentially stable across renders.
 */
export const useAvailableDelegations = (company?: number, options?: { enabled?: boolean }) => {
	const { data, isLoading, error } = useQuery({
		queryKey: [AVAILABLE_DELEGATIONS, company ?? null],
		queryFn: () => fetchAvailableDelegations(company),
		select: mapAvailableDelegations,
		staleTime: TEN_MINUTES_IN_MS,
		gcTime: THIRTY_MINUTES_IN_MS,
		refetchOnWindowFocus: false,
		retry: false,
		enabled: options?.enabled,
	});

	return { data, isLoading, error };
};
